<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXCMDailyPlanItemForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXCMDailyPlanItemList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDailyPlanItemForm from './Form.vue'

export default {
  components: {
    EXCMDailyPlanItemForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdailyplanitem/update/isLoading',
      error: 'excmdailyplanitem/update/error',
      deleteError: 'excmdailyplanitem/del/error',
      deleteLoading: 'excmdailyplanitem/del/isLoading',
      created: 'excmdailyplanitem/create/created',
      deleted: 'excmdailyplanitem/del/deleted',
      retrieved: 'excmdailyplanitem/update/retrieved',
      updated: 'excmdailyplanitem/update/updated',
      violations: 'excmdailyplanitem/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDailyPlanItemList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdailyplanitem/create/reset',
      deleteItem: 'excmdailyplanitem/del/del',
      delReset: 'excmdailyplanitem/del/reset',
      retrieve: 'excmdailyplanitem/update/retrieve',
      updateReset: 'excmdailyplanitem/update/reset',
      update: 'excmdailyplanitem/update/update',
      updateRetrieved: 'excmdailyplanitem/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdailyplanitem ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
